<template>
  <div class="row">
    <div class="col-md-4">
      <base-input v-model="keyword" placeholder="키워드입력"></base-input>
    </div>
    <div class="col-md-2">
      <base-button @click="sendKeyword" type="primary">검색</base-button>
    </div>
  </div>
</template>
<script>
import { BaseInput, BaseButton } from "@/components/index";

export default {
  components: {
    BaseButton,
    BaseInput,
  },
  name: "SimpleSearch",
  data() {
    return {};
  },
  props: {
    keyword: {
      type: String,
      required: false,
    },
  },
  methods: {
    sendKeyword() {
      this.$emit("simpleSearchEvent", {
        keyword: this.keyword,
      });
    },
  },
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}

.extended-forms .progress {
  margin-bottom: 30px;
}
</style>
